import React, { Component } from "react"
import BillingSettingsPlan from "./billing_settings_plan"
import BillingSettingsCardInfo from "./billing_settings_card_info"
import BillingSettingsPaymentHistory from "./billing_settings_payment_history"

const BILLING_OVERVIEW_HEADER_TEXT = "Billing & Invoicing Info"
class AdminDashBillingSettings extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const {
            teamMembers,
            selectedTeamInvites,
            customer,
            setPaymentModalOpen,
            handleCancelPlan,
        } = this.props

        return (
            <div className="billing-settings-container">
                <h4>{BILLING_OVERVIEW_HEADER_TEXT}</h4>
                <BillingSettingsPlan
                    teamMembers={teamMembers}
                    selectedTeamInvites={selectedTeamInvites}
                    customer={customer}
                    handleCancelPlan={handleCancelPlan}
                />
                <BillingSettingsCardInfo
                    customer={customer}
                    setPaymentModalOpen={setPaymentModalOpen}
                />
                <BillingSettingsPaymentHistory customer={customer} />
            </div>
        )
    }
}

export default AdminDashBillingSettings



// WEBPACK FOOTER //
// ./src/components/admin_dash_billing_settings.jsx